module.exports = "<section class=\"gw-dot-indicators\">\n    <div ng-repeat=\"item in model.completedSteps track by $index\">\n        <p class=\"gw-indicator-dot\" ng-class=\"{'gw-complete': item }\">\n            <span>{{$index + 1}}</span>\n        </p>\n    </div>\n    <div>\n        <div class=\"gw-indicator-dot gw-slq-quote-dot\" ng-click=\"quote()\" ng-class=\"{'gw-complete': model.allStepsComplete}\">\n            {{'quoteandbind.pa.directives.templates.pa-quick-indicative.Quote!' | translate}}\n        </div>\n    </div>\n</section>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/directives/templates/pa-quick-quote-edit-state.html
 ** module id = 841
 ** module chunks = 0
 **/